import { render, staticRenderFns } from "./RadiosDefault.vue?vue&type=template&id=6eb46c20&"
import script from "./RadiosDefault.vue?vue&type=script&lang=js&"
export * from "./RadiosDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports